export function LinkToAnchor (pEditor, pAnchor)
{
  this.queryOpenInsertLinkToAnchorDialogEnabled = (pButton, command) =>
  {
    return pEditor.link.inserter.queryOpenInsertLinkDialogEnabled(pButton, command);
  };


  this.openInsertLinkToAnchorDialog = (pButton) =>
  {
    let dParams;

    pEditor.pDialog = pButton.getDialog();
    dParams = pEditor.link.inserter.prepareInsertLinkDialog(pButton);

    if (dParams.isCommandValid)
    {
      pEditor.range.save();

      if (dParams.title.replace(/[\n\r]+/g, '').replace(/(<[\/\!]?[A-Za-z0-9-]+.*?>|(&nbsp;|\s)+)/ig, '') == '') {
        dParams.title = '';
      }

      const link = dParams.link.replace(/^[^#]*\#(.*?)(?:\?|$)/, '$1');

      const params =
      {
        anchorsList: pAnchor.getAnchorsList(),
        title: dParams.title,
        imageLink: dParams.imageLink,
        imageWidth: dParams.imageWidth,
        imageHeight: dParams.imageHeight,
        imageBorder: dParams.imageBorder,
        imageAlign: dParams.imageAlign,
        imageTitle: dParams.imageTitle,
        imageAlt: dParams.imageAlt,
        imageStyle: dParams.imageStyle,
        link: link,
        tooltip: dParams.tooltip,
        isEmptyTitle: (!dParams.title && !dParams.imageLink),
        isEditMode: !!link,
        isLinkEditable: !dParams.title
      };

      window.BEditor.openDialog('openInsertLinkToAnchorDialog', function (params) { pEditor.pThis.execCommand(pButton, 'insertLink', params); }, function () { pEditor.afterCloseDialog(); }, params);

      pEditor.afterOpenDialog();
    }
  };
}